/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type { Listable, Pin, RawPinInventorySearch } from '@zcode/state-type'

export const getDetailLinkText = (
  entity: Listable | Pin<RawPinInventorySearch>,
  fullAddress: string
) => {
  const { isBuilding, headerText, title } = entity
  return isBuilding ? headerText : title || fullAddress
}
